// 公共方法JS:主要用于一些公共方法
import Vue from 'vue';

/**
 * @param {Object} 获取班级信息
 */
export function getSchoolClass(param) {
  return new Promise((resolve, reject) => {
    if(Vue.prototype.$isEmpty(param)){
      param = {};
      param.classStatus = 1; //状态（1正常 2删除）
    }
    Vue.prototype.$get("/jlw/schoolClass/getValues.json",param).then((ret) => {
      resolve(ret);
    }).catch(error => {
      console.log(error);
      reject(ret);
    });;
  })
}
/**
 * @param {Object} 获取课程信息
 */
export function getCourseInfo(param) {
  return new Promise((resolve, reject) => {
    if(Vue.prototype.$isEmpty(param)){
      param = {};
      param.teacherOpenCourseStatus = 1; //状态(1启用 2禁用)
    }
    Vue.prototype.$get("/jlw/teacherOpenCourse/getValues.json",param).then((ret) => {
      resolve(ret)
    }).catch(error => {
      console.log(error);
      reject(ret);
    });;
  })
}

/**
 * @param {Object} 根据开课ID获取班级信息
 */
export function getClassInfo(param) {
  return new Promise((resolve, reject) => {
    if(Vue.prototype.$isEmpty(param.teacherOpenCourseMergeSchoolClassStatus)){
      param.teacherOpenCourseMergeSchoolClassStatus = 1;
    }
    Vue.prototype.$get("/api/teacherOpenCourseMergeSchoolClass/getList.do",param).then((ret) => {
      resolve(ret)
    }).catch(error => {
      console.log(error);
      reject(ret);
    });;
  })
}

/**
 * @param {Object} 获取学生得分List
 */
export function getStudentScoreList(param) {
  return new Promise((resolve, reject) => {
    if(Vue.prototype.$isEmpty(param.teacherOpenCourseQuestionLogStatus)){
      param.teacherOpenCourseQuestionLogStatus = 2; //状态（1正常 2删除）
    }
    Vue.prototype.$post("/api/teacherOpenCourseQuestionLog/studentScoreList.do",param).then((ret) => {
      resolve(ret)
    }).catch(error => {
      console.log(error);
      reject(ret);
    });;
  })
}

/**
 * 查询学生成绩
 * @param handsOnId 实操id
 * @param classId 班级id
 * @param type 1:视频 2:ppt 3:理论 4:实操 5:报告
 * @return
 *  成绩 sumScore
 *  学生id studentId
 *  学号 studentSn
 */
export function getHandsOnAchievementList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.handsOnId) && !Vue.prototype.$isEmpty(param.type)){
      Vue.prototype.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getStudentScore.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(error);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 根据开课ID查询所有实训信息
 * @param teacherOpenCourseId 开课id
 */
export function getPracticalTraining(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      Vue.prototype.$get("/api/teacherOpenCourseHandsOn/getALLInfo.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}
/**
 * 根据教师名称获取课程名称
 * @param teacherId 开课id
 */
export function getCourseList(param) {
  return new Promise((resolve, reject) => {
    let identityInfo = Vue.prototype.$ls.get(Vue.prototype.$getKeyInfo("identityInfo"));
    if(!Vue.prototype.$isEmpty(identityInfo.teacherId)){
      Vue.prototype.$get("/api/teacherOpenCourseMergeTeacher/getList.do",{teacherId:identityInfo.teacherId,teacherOpenCourseMergeTeacherStatus:1}).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 根据归属课程ID查询章
 * @param courseInfoParentId 开课id
 */
export function getCourseInfoList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      param.courseInfoStatus = 1;
      param.courseInfoType = 2;
      Vue.prototype.$get("/api/teacherOpenCourseMergeCourseInfo/getList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 根据章ID查节
 * @param courseInfoParentId 开课id
 */
export function getCourseJointList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.courseInfoParentId)){
      param.courseInfoStatus = 1;
      param.courseInfoType = 3;
      Vue.prototype.$get("/api/teacherOpenCourseMergeCourseInfo/getList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 获取章节练习下拉列表数据。获取题目配置中的章节配置。
 * @param courseInfoParentId 开课id
 */
export function getQuestionSettingSelectList(param) {
  return new Promise((resolve, reject) => {
    let tempParams = {}
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      // 不查询用户得分情况，和平均分等信息
      tempParams.notSelectOther = true;
      tempParams.teacherOpenCourseQuestionSettingStatus = 1;
      Object.assign(tempParams, param);
      Vue.prototype.$get("/api/teacherOpenCourseQuestionSetting/getList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * @param {Object} param
 * 获取归属课程 及 归属章节的获取
 */
export function getCourseMergeList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      if(Vue.prototype.$isEmpty(param.courseInfoType)){
        param.courseInfoType = 1; //1:课程 2：章节
      }
      Vue.prototype.$post("/api/teacherOpenCourseMergeCourseInfo/getPageList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * @param {Object} param
 * 获取题目信息列表
 */
export function getQuestionList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      if(!Vue.prototype.$isEmpty(param.questionStatus)){
        param.questionStatus = 1; //1：正常
      }
      Vue.prototype.$post("/api/teacherOpenCourseMergeResourcesQuestion/getPageList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}
/**
 * @param {Object} param
 * 获取题目信息列表 【考证辅导】
 */
export function getCoachQuestionList(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.questionStatus)){
      param.questionStatus = 1; //1：正常
    }
    Vue.prototype.$post("/api/resourcesQuestion/list.do",param).then((ret) => {
      resolve(ret)
    }).catch(error => {
      reject(ret);
    });
  })
}

// 考试信息
/**
 * @param {Object} param
 * 根据开课ID获取所有考试信息
 * teacherOpenCourseQuestionSettingType：
 * HOMEWORK_QUESTION("作业-题目类型"),
   HOMEWORK_FILE("作业-附件类型"),
   EXAM("考试"),
   CHAPTER_EXERCISE("章节练习");
 */
export function getExamAll(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      if(!Vue.prototype.$isEmpty(param.teacherOpenCourseQuestionSettingStatus)){
        param.teacherOpenCourseQuestionSettingStatus = 1; //1：正常
      }
      Vue.prototype.$get("/api/teacherOpenCourseQuestionSetting/getList.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}


//实训获取成绩分数
export function getScoreByHandsOnId(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.handsOnId)){
      Vue.prototype.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getScoreByHandsOnId",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}


/**
 * 获取作业相关的分析数据
 * @param param
 * {teacherOpenCourseId(必传), questionSettingType(必传), questionSettingId(非必传,代表查询单套卷子的分析) }
 * @returns {Promise<unknown>}
 */
export function getQuestionAnalysisData(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId) &&
       !Vue.prototype.$isEmpty(param.questionSettingType)){
      Vue.prototype.$post("/api/teacherOpenCourseQuestionSetting/analysis.do",param).then((ret) => {
        resolve(ret)
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 获取学生提问数
 * @param param
 * {teacherOpenCourseId(必传)}
 * @returns {Promise<unknown>}
 */
export function getStudentAskUnReadCount(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      Vue.prototype.$get("/api/teacherOpenCourseChatLog/getStudentAskUnReadCount.do",param).then((ret) => {
        resolve(ret);
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}

/**
 * 获取教师提问数
 * @param param
 * {teacherOpenCourseId(必传)}
 * @returns {Promise<unknown>}
 */
export function getTeacherAskUnReadCount(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      Vue.prototype.$get("/api/teacherOpenCourseChatLog/getTeacherAskUnReadCount.do",param).then((ret) => {
        resolve(ret);
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}
/**
 * 获取知识点
 * @param param
 * {teacherOpenCourseId(必传)}
 * @returns {Promise<unknown>}
 */
export function getBindingKnowledgePoint(param) {
  return new Promise((resolve, reject) => {
    if(!Vue.prototype.$isEmpty(param.teacherOpenCourseId)){
      Vue.prototype.$post("/api/teacherOpenCourseKnowledgePoint/getBindingKnowledgePoint.do",param).then((ret) => {
        resolve(ret);
      }).catch(error => {
        reject(ret);
      });
    }else{
      resolve({code: 500,msg: "数据缺失！",data:null});
    }
  })
}



// WEBPACK FOOTER //
// ./src/common/getInfo.js